import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";

@Component({
  selector: "app-modal-fermeture",
  templateUrl: "./modal-fermeture.component.html",
  styleUrls: ["./modal-fermeture.component.scss"],
  standalone: false,
})
export class ModalFermetureComponent implements OnInit {
  commentaire: string = "";
  pdv: any;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams
  ) {
    this.pdv = this.navParams.get("pdv");
  }

  ngOnInit() {}

  annuler() {
    this.modalCtrl.dismiss();
  }

  enregistrer() {
    this.modalCtrl.dismiss({
      commentaire: this.commentaire,
      confirmed: true,
    });
  }
}
